import GridTooltip from "./GridTooltip"

export default {
    template: `<grid-tooltip :tooltip="value">{{ value }}</grid-tooltip>`,

    components: {GridTooltip},

    data() {
        return {
            value: ''
        }
    },

    created() {
        this.value = this.params.value
    }
}
